import type { Page } from '@subaio/utils'

import type { Container } from 'lib/container'

import type { UserAuth } from './store'

export const getContainer = (containers: Record<string, Container>, page: Page | null, userAuth: UserAuth) => {
	if (userAuth.status === 'expired') return containers.AuthExpired

	const name = page?.name ?? ''
	return containers[name] ?? containers.NotFound
}
